import { Link } from "react-router-dom";
import { Clock3, Mail } from "lucide-react";
import SEO from "../SEO/SEO";
import "./maintenance.scss";

const MaintenancePage = () => (
  <main className="maintenance-page">
    <SEO
      title="Scheduled Maintenance | Teleport Now"
      description="Teleport Now is temporarily unavailable while scheduled maintenance is in progress."
      canonicalPath="/"
      robots="noindex, nofollow"
    />

    <div className="maintenance-page__glow maintenance-page__glow--top" aria-hidden="true" />
    <div className="maintenance-page__glow maintenance-page__glow--bottom" aria-hidden="true" />

    <section className="maintenance-card" aria-labelledby="maintenance-title">
      <img
        className="maintenance-card__logo"
        src="/images/navbar-logo.svg"
        alt="Teleport Now"
      />

      <div className="maintenance-card__status">
        <span className="maintenance-card__status-dot" aria-hidden="true" />
        Scheduled maintenance
      </div>

      <div className="maintenance-card__icon" aria-hidden="true">
        <Clock3 size={34} strokeWidth={1.8} />
      </div>

      <h1 id="maintenance-title">We’ll be back shortly.</h1>
      <p className="maintenance-card__intro">
        We’re making a few improvements to give you a smoother Teleport Now experience.
        Thank you for your patience while our website is temporarily unavailable.
      </p>

      <div className="maintenance-card__support">
        <Mail size={18} aria-hidden="true" />
        <span>Need help?</span>
        <a href="mailto:support@teleportapp.sg">support@teleportapp.sg</a>
      </div>

      <nav className="maintenance-card__legal" aria-label="Legal information">
        <Link to="/privacy-policy">Privacy Policy</Link>
        <span aria-hidden="true">•</span>
        <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
      </nav>
    </section>

    <p className="maintenance-page__copyright">
      © {new Date().getFullYear()} Teleport Now. All rights reserved.
    </p>
  </main>
);

export default MaintenancePage;
